export enum SystemeEntiteEnum {
  CREDIT = 'CREDIT',
  DGAG = 'DGAG',
  COMPTE_SCGP = 'COMPTE_SCGP',
  AP = 'AP',
}
